import type {RouletteInfoQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Roulette 도메인 Query Key 관리
 */
export const ROULETTE_QUERY_KEY_MAP = {
  /**
   * 룰렛 정보 조회
   * Origin: useRouletteInfoQuery.getKey
   */
  rouletteInfo: (variables: RouletteInfoQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'rouletteInfo', variables] as const,
} as const;

/**
 * Roulette 도메인 Mutation Key 관리
 */
export const ROULETTE_MUTATION_KEY_MAP = {
  /**
   * 룰렛 뽑기
   * Origin: useRouletteDrawMutation (getKey 없음)
   */
  rouletteDraw: 'rouletteDraw',
} as const;
